<script setup lang="ts">
import Tag from "./detail/tag.vue";
import Region from "./detail/region.vue";
import Manufacturer from "./detail/manufacturer.vue";
import Media from "./detail/media.vue";
import Release from "./detail/release.vue";
import Franchise from "./detail/franchise.vue";

defineProps<{
  consoleId: string;
}>();
</script>

<template>
  <section class="tab-console">
    <div class="content">
      <!-- Tags -->
      <Tag :console-id="consoleId" />

      <!-- Regions -->
      <Region :console-id="consoleId" />

      <!-- Manufacturers -->
      <Manufacturer :console-id="consoleId" />

      <!-- medias -->
      <Media :console-id="consoleId" />

      <!-- Releases -->
      <Release :console-id="consoleId" />

      <!-- Franchises -->
      <Franchise :console-id="consoleId" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-console {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-console {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
